import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoText = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 67,
	height: 25,
	viewBox: "0 0 67 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.04812 0.347656C2.44445 0.347656 0 2.26305 0 5.16136C0 7.60601 1.20962 9.04257 4.18329 10.1011L6.52693 10.9328C8.36657 11.5628 9.14779 12.2685 9.14779 13.6295C9.14779 15.2424 7.86256 16.2253 5.72052 16.2253C3.83048 16.2253 1.71364 15.192 0.0252005 13.327V16.3261C1.23483 17.6367 3.32647 18.6952 5.67012 18.6952C9.42499 18.6952 11.9702 16.6034 11.9702 13.4782C11.9702 10.9328 10.685 9.44581 7.61056 8.3873L5.0905 7.50521C3.47767 6.95075 2.82246 6.24507 2.82246 5.06055C2.82246 3.6492 4.00688 2.81751 6.02292 2.81751C7.76176 2.81751 9.7526 3.69961 11.315 5.26217V2.33866C10.0298 1.12893 7.96336 0.347656 6.04812 0.347656Z",
			fill: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3515 10.7563V11.6636C20.5955 11.0336 19.2347 10.5547 17.7479 10.5547C15.127 10.5547 13.1866 12.2433 13.1866 14.6124C13.1866 16.9562 15.0262 18.6952 17.5967 18.6952C19.3355 18.6952 20.7971 17.8383 21.3515 16.5026V18.3928H23.9724V10.6303C23.9724 7.50521 21.6287 5.43859 18.1763 5.43859C16.6138 5.43859 14.9506 6.01825 13.8166 7.07676V9.3702C14.9002 8.26128 16.3366 7.65643 17.7227 7.65643C19.9403 7.65643 21.3515 8.84095 21.3515 10.7563ZM15.7066 14.5368C15.7066 13.3018 16.7902 12.3945 18.3527 12.3945C19.5119 12.3945 20.6711 12.8482 21.3515 13.5286V13.6042C21.2759 15.3684 19.9907 16.7042 18.3527 16.7042C16.8154 16.7042 15.7066 15.7717 15.7066 14.5368Z",
			fill: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.038 18.3928H32.2305L37.825 5.74103H35.0025L31.1469 14.9904L27.3416 5.74103H24.4435L30.038 18.3928Z",
			fill: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.9141 18.3928H45.1066L50.7011 5.74103H47.8786L44.0229 14.9904L40.2177 5.74103H37.3196L42.9141 18.3928Z",
			fill: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.0937 24.1894H55.513L63.6528 5.74103H60.8051L56.9242 15.0156L53.1693 5.74103H50.2209L55.639 18.0651L53.0937 24.1894Z",
			fill: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.6966 14.4359C63.4366 14.4359 62.5546 15.318 62.5546 16.5782C62.5546 17.8131 63.4366 18.6952 64.6966 18.6952C66.007 18.6952 66.9143 17.8131 66.9143 16.5782C66.9143 15.318 66.007 14.4359 64.6966 14.4359Z",
			fill: "#1D1D1D"
		})
	]
});
export default SvgLogoText;
